export const getLoggedInUser = (state) => {
  const loggedInUser = state.appState?.loggedInUser;
  return loggedInUser;
};
